<template>
  <div style="width:100%;height: 100%;position:relative;overflow: visible">
    <div v-if="cityName!=='延平区'" style="position: absolute;right: 100px;bottom: 30px;z-index: 100;"
         @click="changeCity({name:'延平区',data:{cityId:'YP000000'}})"><img src="../../../assets/img/bigScreen/big-back.png"
                                                                            style="width: 54px;height: 49px;cursor: pointer"/></div>

    <!-- 图例 -->
    <div v-if="cityName!=='延平区'" style="position: absolute;left: 30px;top: 30px;z-index: 100;background-color: rgba(0, 0, 0, 0.7);padding: 15px;border-radius: 8px;border: 2px solid #00ff00;">
      <h3 style="color: #ffffff;margin-top: 0;margin-bottom: 15px;font-size: 16px;text-align: center;">图例说明</h3>
      <div style="display: flex;flex-direction: column;gap: 10px;">
        <div style="display: flex;align-items: center;gap: 10px;cursor: pointer;" @click="toggleMarker('workstation')" :style="{opacity: showMarkers.workstation ? 1 : 0.5}">
          <img src="../../../assets/img/bigScreen/list2.png" style="width: 20px;height: 20px;" />
          <span style="color: #ffffff;font-size: 14px;">工作站</span>
          <span style="margin-left: auto;color: #00ff00;font-size: 16px;">{{ showMarkers.workstation ? '✓' : '✗' }}</span>
        </div>
        <div style="display: flex;align-items: center;gap: 10px;cursor: pointer;" @click="toggleMarker('teachingPoint')" :style="{opacity: showMarkers.teachingPoint ? 1 : 0.5}">
          <img src="../../../assets/img/bigScreen/list1.png" style="width: 20px;height: 20px;" />
          <span style="color: #ffffff;font-size: 14px;">教学点</span>
          <span style="margin-left: auto;color: #00ff00;font-size: 16px;">{{ showMarkers.teachingPoint ? '✓' : '✗' }}</span>
        </div>
        <div style="display: flex;align-items: center;gap: 10px;cursor: pointer;" @click="toggleMarker('demonstrationBase')" :style="{opacity: showMarkers.demonstrationBase ? 1 : 0.5}">
          <img src="../../../assets/img/bigScreen/list3.png" style="width: 20px;height: 20px;" />
          <span style="color: #ffffff;font-size: 14px;">示范基地</span>
          <span style="margin-left: auto;color: #00ff00;font-size: 16px;">{{ showMarkers.demonstrationBase ? '✓' : '✗' }}</span>
        </div>
      </div>
    </div>

    <!-- 特殊教学点信息框 -->
    <div v-if="specialTeachingPoint && showMarkers.teachingPoint &&cityName==='王台镇'"
         class="special-teaching-point-info"
         :style="{
           position: 'absolute',
           right: '30px',
           top: '50px',
           zIndex: 50
         }">
      <div class="info-box">
        <div class="info-header">
          <h3>{{ specialTeachingPoint.name }}</h3>
        </div>
        <div class="info-content">
          <div class="info-image" v-if="specialTeachingPoint.imageUrl">
            <el-image
              v-for="item in parseUploadData(specialTeachingPoint.imageUrl, {id: specialTeachingPoint.data.id, fieldName: 'imageUrl', asImage: true})"
              :key="item.url"
              :src="item.url"
              :preview-src-list="getPictureList(specialTeachingPoint.imageUrl, {id: specialTeachingPoint.data.id, fieldName: 'imageUrl', asImage: true})"
              fit="cover"
              class="teaching-point-image"
            >
              <div slot="error" class="image-error">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="info-details">
            <!--            <p v-if="specialTeachingPoint.location"><strong>位置:</strong> {{ specialTeachingPoint.location }}</p>-->
            <p v-if="specialTeachingPoint.description"><strong>简介:</strong> {{ specialTeachingPoint.description }}</p>
          </div>
        </div>
      </div>
      <!--      <div class="arrow" :style="{-->
      <!--        position: 'absolute',-->
      <!--        left: '-20px',-->
      <!--        top: arrowTop + 'px',-->
      <!--        width: 0,-->
      <!--        height: 0,-->
      <!--        borderTop: '15px solid transparent',-->
      <!--        borderBottom: '15px solid transparent',-->
      <!--        borderRight: '20px solid rgba(255, 0, 0, 0.9)'-->
      <!--      }"></div>-->
    </div>

    <div id="bigScreen-map" style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;overflow: visible"></div>
    <el-dialog></el-dialog>
  </div>
</template>

<script>
import { WorkstationController, TeachingPointController, DemonstrationBaseController } from '../../../api';
import TechPersonnelController from '../../../api/Controller/TechPersonnelController';
import { getTechPersonnelStaticData } from '../../../utils/staticData';
import { uploadMixin } from '@/core/mixins';
export default {
  name: 'bigScreenMap',
  mixins: [uploadMixin],
  data () {
    return {
      cityName: '延平区',
      cityId: 'YP000000',
      timer: null,
      myChart: null,
      yanping: require('./city/yanping.json'),
      mapRotation: -10, // 地图旋转角度，正数为顺时针旋转
      mapAspectScale: 1, // 地图宽高比，1表示保持原始比例，值越小地图越扁平
      ypMap: {
        延平区: require('./city/yanping.json'),
        西芹镇: require('./city/西芹镇.json'),
        南山镇: require('./city/南山镇.json'),
        四鹤街道: require('./city/四鹤街道.json'),
        塔前镇: require('./city/塔前镇.json'),
        夏道镇: require('./city/夏道镇.json'),
        大横镇: require('./city/大横镇.json'),
        太平镇: require('./city/太平镇.json'),
        峡阳镇: require('./city/峡阳镇.json'),
        巨口乡: require('./city/巨口乡.json'),
        来舟镇: require('./city/来舟镇.json'),
        梅山街道: require('./city/梅山街道.json'),
        樟湖镇: require('./city/樟湖镇.json'),
        水东街道: require('./city/水东街道.json'),
        水南街道: require('./city/水南街道.json'),
        洋后镇: require('./city/洋后镇.json'),
        炉下镇: require('./city/炉下镇.json'),
        王台镇: require('./city/王台镇.json'),
        紫云街道: require('./city/紫云街道.json'),
        茫荡镇: require('./city/茫荡镇.json'),
        赤门乡: require('./city/赤门乡.json'),
        黄墩街道: require('./city/黄墩街道.json')
      },
      data: [],
      mapData: [], // 工作站数据
      teachingPointData: [], // 教学点数据
      demonstrationBaseData: [], // 示范基地数据
      specialTeachingPoint: null, // 特殊教学点数据
      specialTeachingPointInfoTop: 50, // 特殊教学点信息框顶部位置
      arrowTop: 50, // 箭头顶部位置
      showMarkers: {
        workstation: true, // 工作站标记是否显示
        teachingPoint: true, // 教学点标记是否显示
        demonstrationBase: true // 示范基地标记是否显示
      },
      // 存储各街镇的特派员统计数据
      techPersonnelStats: {},
      // 当前鼠标悬停的街镇名称
      currentHoverTown: ''

    }
  },
  mounted () {
    // 确保 DOM 完全渲染后再初始化地图
    this.$nextTick(() => {
      this.bigScreenMap();
      // 初始化时一次性加载所有街镇的特派员数据
      this.getAllTechPersonnelStats();
    });
  },
  methods: {
    // GCJ02转WGS84坐标系
    gcj02towgs84 (lng, lat) {
      const pi = 3.14159265358979324;
      const a = 6378245.0;
      const ee = 0.00669342162296594323;

      if (this.out_of_china(lng, lat)) {
        return [lng, lat];
      }

      let dlat = this.transformlat(lng - 105.0, lat - 35.0);
      let dlng = this.transformlng(lng - 105.0, lat - 35.0);
      let radlat = lat / 180.0 * pi;
      let magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      let sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * pi);
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * pi);
      let mglat = lat + dlat;
      let mglng = lng + dlng;
      return [lng * 2 - mglng, lat * 2 - mglat];
    },

    transformlat (lng, lat) {
      const pi = 3.14159265358979324;
      let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * pi) + 20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lat * pi) + 40.0 * Math.sin(lat / 3.0 * pi)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(lat / 12.0 * pi) + 320 * Math.sin(lat * pi / 30.0)) * 2.0 / 3.0;
      return ret;
    },

    transformlng (lng, lat) {
      const pi = 3.14159265358979324;
      let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * pi) + 20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lng * pi) + 40.0 * Math.sin(lng / 3.0 * pi)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(lng / 12.0 * pi) + 300.0 * Math.sin(lng * pi / 30.0)) * 2.0 / 3.0;
      return ret;
    },

    out_of_china (lng, lat) {
      return (lng < 73.66 || lng > 135.05 || lat < 3.86 || lat > 53.55);
    },

    bigScreenMap () {
      var yanping = this.yanping;
      var mapContainer = document.getElementById('bigScreen-map');

      // 检查容器尺寸
      console.log('Map container size:', mapContainer.offsetWidth, mapContainer.offsetHeight);

      // 确保容器有正确的尺寸后再初始化地图
      if (mapContainer.offsetWidth === 0 || mapContainer.offsetHeight === 0) {
        setTimeout(() => this.bigScreenMap(), 100);
        return;
      }

      var myChart = this.$echarts.init(mapContainer);

      // 统一设置地图缩放级别、旋转角度和宽高比
      let zoom = 1.2 // 等比例放大延平区地图
      if (this.cityName !== '延平区') {
        zoom = 0.9 // 等比例放大其他区域地图
      }
      const rotation = this.mapRotation;
      const aspectScale = this.mapAspectScale;
      var option = {
        title: {
          top: 20,
          text: '',
          subtext: '',
          x: 'center',
          textStyle: {
            color: '#FFF'
          }
        },
        // 提示框组件
        tooltip: {
          show: true,
          // 触发类型：数据项图形触发
          trigger: 'item',
          padding: 15,
          borderWidth: 2,
          borderColor: '#00ff00',
          backgroundColor: 'rgba(5,21,35,0.95)',
          textStyle: {
            color: '#fff',
            fontSize: 13
          },
          extraCssText: 'box-shadow: 0 0 20px rgba(0,255,0,0.3);border-radius: 8px;',
          formatter: (params) => {
            return this.getTooltipContent(params);
          }
        },
        legend: {

          show: false

        },
        color: 'red',
        geo: [
          {
            map: 'yanping',
            aspectScale: aspectScale,
            zoom: zoom,
            layoutCenter: ['50%', '50%'],
            layoutSize: '100%',
            show: true,
            roam: false,
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#a7ffe5',
                borderWidth: 2,
                shadowColor: '#8cd3ef',
                shadowOffsetY: 10,
                shadowBlur: 120,
                areaColor: 'transparent'
              }
            }
          },
          // 重影
          {
            type: 'map',
            map: 'yanping',
            zlevel: -1,
            aspectScale: aspectScale,
            zoom: zoom,
            layoutCenter: ['50%', '51%'],
            layoutSize: '100%',
            roam: false,
            silent: true,
            itemStyle: {
              normal: {
                borderWidth: 1,
                // borderColor:"rgba(17, 149, 216,0.6)",
                borderColor: 'rgba(116,252,204,0.7)',
                shadowColor: 'rgba(30,240,238,0.5)',
                shadowOffsetY: 5,
                shadowBlur: 15,
                areaColor: 'rgba(5,21,35,0.1)'
              }
            }
          },
          {
            type: 'map',
            map: 'yanping',
            zlevel: -2,
            aspectScale: aspectScale,
            zoom: zoom,
            layoutCenter: ['50%', '52%'],
            layoutSize: '100%',
            roam: false,
            silent: true,
            itemStyle: {
              normal: {
                borderWidth: 1,
                // borderColor: "rgba(57, 132, 188,0.4)",
                borderColor: 'rgba(255,255,255,0.6)',
                shadowColor: 'rgb(30,240,153)',
                shadowOffsetY: 5,
                shadowBlur: 15,
                areaColor: 'transpercent'
              }
            }
          },
          {
            type: 'map',
            map: 'yanping',
            zlevel: -3,
            aspectScale: aspectScale,
            zoom: zoom,
            layoutCenter: ['50%', '53%'],
            layoutSize: '100%',
            roam: false,
            silent: true,
            itemStyle: {
              normal: {
                borderWidth: 1,
                // borderColor: "rgba(11, 43, 97,0.7)",
                borderColor: 'rgba(255,255,255,0.4)',
                shadowColor: 'rgb(30,240,201)',
                shadowOffsetY: 15,
                shadowBlur: 10,
                areaColor: 'transpercent'
              }
            }
          },
          {
            type: 'map',
            map: 'yanping',
            zlevel: -4,
            aspectScale: aspectScale,
            zoom: zoom,
            layoutCenter: ['50%', '54%'],
            layoutSize: '100%',
            roam: false,
            silent: true,
            itemStyle: {
              normal: {
                borderWidth: 5,
                // borderColor: "rgba(11, 43, 97,0.7)",
                borderColor: 'rgba(5,57,26,0.7)',
                shadowColor: 'rgba(29,165,113,0.7)',
                shadowOffsetY: 15,
                shadowBlur: 10,
                areaColor: 'rgba(5,21,35,0.1)'
              }
            }
          }
        ],
        series: [

          {
            name: '延平区',
            type: 'map',
            map: 'yanping', // 自定义扩展图表类型
            aspectScale: aspectScale,
            zoom: zoom, // 缩放
            rotation: rotation, // 地图旋转角度
            showLegendSymbol: true,
            label: {
              normal: {
                show: true,
                textStyle: {color: '#fff', fontSize: '12', fontFamily: '微软雅黑'}
              },
              emphasis: {
                // show: false,
              }
            },
            itemStyle: {
              normal: {
                areaColor: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(1,21,11,0.75)' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: 'rgba(1,60,31,0.75)' // 0% 处的颜色
                    },

                    {
                      offset: 1,
                      color: '#01b9b7' // 50% 处的颜色
                    }
                  ],
                  global: false // 使用局部坐标系统
                },
                borderColor: '#c2d4e7',
                borderWidth: 1
              },
              emphasis: {
                show: false,
                color: '#fff',
                areaColor: 'rgba(0,254,233,0.6)' // 高亮蓝绿色
              }
            },
            layoutCenter: ['50%', '50%'],
            layoutSize: '100%',
            markPoint: {
              symbol: 'circle'
            },
            data: this.data
          }
        ]
      };

      // Validate GeoJSON data before registering
      if (yanping && yanping.features) {
        // Process GeometryCollection and convert to supported types
        const processedFeatures = [];

        yanping.features.forEach(feature => {
          if (feature && feature.geometry) {
            if (feature.geometry.type === 'GeometryCollection' && feature.geometry.geometries) {
              // Convert GeometryCollection to multiple features
              feature.geometry.geometries.forEach(geometry => {
                if (geometry.type === 'Polygon' && geometry.coordinates) {
                  processedFeatures.push({
                    ...feature,
                    geometry: {
                      type: 'Polygon',
                      coordinates: geometry.coordinates
                    }
                  });
                }
              });
            } else if (feature.geometry.coordinates) {
              // Normal feature with single geometry
              processedFeatures.push(feature);
            }
          }
        });

        if (processedFeatures.length > 0) {
          // Create a new FeatureCollection with processed features
          const processedGeoJSON = {
            ...yanping,
            features: processedFeatures
          };

          this.$echarts.registerMap('yanping', processedGeoJSON);
          myChart.showLoading();
          try {
            myChart.setOption(option, true);

            // 添加鼠标事件监听
            this.addTeachingPointHoverEvent(myChart);
          } catch (error) {
            console.error('设置地图选项失败：', error);
          } finally {
            myChart.hideLoading();
          }

          // 确保地图完整显示
          setTimeout(() => {
            if (myChart) {
              myChart.dispatchAction({ type: 'restore' });
            }
          }, 100);

          myChart.on('click', this.changeCity);

          // 鼠标移动到地图区域时，获取该区域的特派员统计数据
          myChart.on('mouseover', (params) => {
            if (params.name && params.name !== '延平区') {
              this.getTechPersonnelStats(params.name);
            }
          });

          // 鼠标离开地图区域时，清空当前悬停的街镇
          myChart.on('mouseout', () => {
            this.currentHoverTown = '';
          });

          // 地图初始化完成后再查询数据
          if (this.cityName && this.cityName !== '延平区') {
            // 使用setTimeout确保地图完全渲染后再查询数据
            setTimeout(() => {
              this.queryLocationData(this.cityName);
              // 加载当前街镇的特派员数据
              this.getTechPersonnelStats(this.cityName);

              // 延迟调整信息框位置，确保地图和数据都已加载完成
              setTimeout(() => {
                this.adjustInfoBoxPosition();
              }, 300);
            }, 100);
          } else {
            // 如果是延平区，加载延平区的特派员数据
            this.getTechPersonnelStats('延平区');
          }
        } else {
          console.error('GeoJSON data contains no valid features after processing');
          if (myChart) {
            myChart.hideLoading();
          }
        }
      } else {
        console.error('Invalid GeoJSON format: missing features');
        if (myChart) {
          myChart.hideLoading();
        }
      }

      // 使用刚指定的配置项和数据显示图表。
      // myChart.setOption(option, true);
      this.myChart = myChart;
      /* }); */
      window.addEventListener('resize', () => {
        // 第六步，执行echarts自带的resize方法，即可做到让echarts图表自适应
        this.myChart.resize();
      });

      // 确保地图在初始加载后正确显示
      setTimeout(() => {
        if (this.myChart) {
          this.myChart.resize();
        }
      }, 200);
    },
    changeCity (param) {
      console.log('点击事件参数:', param)
      console.log('param.data:', param.data)
      console.log('param.componentType:', param.componentType)
      console.log('param.seriesType:', param.seriesType)
      console.log('param.seriesName:', param.seriesName)
      console.log('param.name:', param.name)

      // 检查是否点击的是标记（工作站、教学点、示范基地）
      // 通过 componentType 和 seriesType 来判断是否是 scatter 系列
      if (param.componentType === 'series' && param.seriesType === 'scatter') {
        console.log('点击了标记点，不执行切换城市操作');
        return;
      }

      // 检查是否点击的是标记（工作站、教学点、示范基地）
      const markerType = param.data?.type || param.data?.data?.type;
      if (markerType && (markerType === 'workstation' || markerType === 'teachingPoint' || markerType === 'demonstrationBase')) {
        console.log('点击了标记，不执行切换城市操作:', markerType);
        return;
      }

      // 检查 seriesName 是否为标记相关的名称
      if (param.seriesName && (param.seriesName === '教学点' || param.seriesName === 'specialTeachingPoint' || param.seriesName === '工作站' || param.seriesName === '示范基地')) {
        console.log('点击了标记系列，不执行切换城市操作:', param.seriesName);
        return;
      }

      // 临时设置：只有王台镇可以点击
      // TODO: 以后需要移除这个限制
      // if (!(param.name === '王台镇' || param.name === '延平区')) {
      //   console.log('当前只有王台镇可以点击，其他区域暂不可点击:', param.name);
      //   return;
      // }

      this.cityName = param.name;
      // Check if the GeoJSON data exists for the selected city
      if (this.ypMap[param.name]) {
        this.yanping = this.ypMap[param.name];

        // 无论地图是否初始化，都需要重新加载地图以更新边界
        this.bigScreenMap();

        // Emit the changeCity event with cityId
        let cityId = param.data?.cityId;
        // If cityId is not available, generate it from city name
        if (!cityId) {
          // Convert city name to pinyin and use as cityId (simple implementation)
          cityId = param.name.replace(/\s+/g, '') + '0000';
        }
        this.$emit('changeCity', param.name, cityId);

        // 加载新选中街镇的特派员数据
        this.getTechPersonnelStats(param.name);
      } else {
        console.error(`GeoJSON data not found for city: ${param.name}`);
      }
    },
    // 查询工作站、教学点和示范基地信息
    queryLocationData (location) {
      console.log('开始查询区域数据:', location);

      // 使用Promise.all确保所有数据查询完成后再更新地图
      Promise.all([
        this.queryWorkstations(location),
        this.queryTeachingPoints(location),
        this.queryDemonstrationBases(location)
      ]).then(() => {
        console.log('所有数据查询完成，准备更新地图');
        // 所有数据查询完成后，延迟更新地图，确保数据已正确赋值
        setTimeout(() => {
          this.forceUpdateMap();
        }, 100);
      }).catch(err => {
        console.error('数据查询失败:', err);
      });
    },

    // 查询工作站信息
    queryWorkstations (location) {
      // 返回Promise，便于Promise.all使用
      return new Promise((resolve, reject) => {
        // 构造查询参数
        const params = {
          workstationDtoFilter: {
            location: location // 以地图名称作为位置查询条件
          }
        };

        // 调用API查询工作站信息
        WorkstationController.list(this, params).then(res => {
          console.log('工作站API返回结果：', res);
          // 统一使用res.data.list格式（与教学点API保持一致）
          if (res && res.data && res.data.dataList) {
            // 将查询结果转换为地图标记需要的数据格式
            this.mapData = res.data.dataList.map(workstation => {
              // 只保留有经纬度的工作站
              if (workstation.longitude && workstation.latitude) {
                // 转换坐标系：GCJ02转WGS84
                const [wgsLng, wgsLat] = this.gcj02towgs84(workstation.longitude, workstation.latitude);
                return {
                  name: workstation.name,
                  value: [wgsLng, wgsLat],
                  data: {
                    cityId: workstation.id,
                    type: 'workstation', // 标记类型为工作站
                    ...workstation // 保留完整的工作站信息
                  }
                };
              }
              return null;
            }).filter(Boolean); // 过滤掉没有经纬度的工作站

            console.log('查询到的工作站信息：', this.mapData);
          } else {
            console.error('查询工作站信息失败：', res);
            this.mapData = [];
          }
          resolve();
        }).catch(err => {
          console.error('查询工作站信息出错：', err);
          this.mapData = [];
          reject(err);
        });
      });
    },

    // 查询教学点信息
    queryTeachingPoints (location) {
      // 返回Promise，便于Promise.all使用
      return new Promise((resolve, reject) => {
        // 构造查询参数
        const params = {
          teachingPointDtoFilter: {
            location: location // 以地图名称作为位置查询条件
          }
        };

        // 调用API查询教学点信息
        TeachingPointController.list(this, params).then(res => {
          console.log('教学点API返回结果：', res);
          // 兼容不同的API返回格式：res.data.list 或 res.data.dataList
          let teachingPoints = [];
          if (res && res.data) {
            if (res.data.dataList) {
              teachingPoints = res.data.dataList;
            } else if (res.data.list) {
              teachingPoints = res.data.list;
            }
          }

          if (teachingPoints.length > 0) {
            // 将查询结果转换为地图标记需要的数据格式
            this.teachingPointData = teachingPoints.map(teachingPoint => {
              // 只保留有经纬度的教学点
              if (teachingPoint.longitude && teachingPoint.latitude) {
                // 转换坐标系：GCJ02转WGS84
                const [wgsLng, wgsLat] = this.gcj02towgs84(teachingPoint.longitude, teachingPoint.latitude);
                return {
                  id: teachingPoint.id, // 添加id字段，用于后续的图标判断
                  name: teachingPoint.pointName,
                  value: [wgsLng, wgsLat],
                  data: {
                    cityId: teachingPoint.id,
                    type: 'teachingPoint', // 标记类型为教学点
                    ...teachingPoint // 保留完整的教学点信息
                  }
                };
              }
              return null;
            }).filter(Boolean); // 过滤掉没有经纬度的教学点

            console.log('查询到的教学点信息：', this.teachingPointData);
          } else {
            console.error('查询教学点信息失败：', res);
            this.teachingPointData = [];
          }
          resolve();
        }).catch(err => {
          console.error('查询教学点信息出错：', err);
          this.teachingPointData = [];
          reject(err);
        });
      });
    },

    // 查询示范基地信息
    queryDemonstrationBases (location) {
      // 返回Promise，便于Promise.all使用
      return new Promise((resolve, reject) => {
        // 构造查询参数
        const params = {
          demonstrationBaseDtoFilter: {
            address: location // 以地图名称作为位置查询条件
          }
        };

        // 调用API查询示范基地信息
        DemonstrationBaseController.list(this, params).then(res => {
          console.log('示范基地API返回结果：', res);
          // 统一使用res.data.list格式（与其他API保持一致）
          if (res && res.data && res.data.dataList) {
            // 将查询结果转换为地图标记需要的数据格式
            this.demonstrationBaseData = res.data.dataList.map(base => {
              // 只保留有经纬度的示范基地
              if (base.longitude && base.latitude) {
                // 转换坐标系：GCJ02转WGS84
                const [wgsLng, wgsLat] = this.gcj02towgs84(base.longitude, base.latitude);
                return {
                  name: base.name,
                  value: [wgsLng, wgsLat],
                  data: {
                    cityId: base.id,
                    type: 'demonstrationBase', // 标记类型为示范基地
                    ...base // 保留完整的示范基地信息
                  }
                };
              }
              return null;
            }).filter(Boolean); // 过滤掉没有经纬度的示范基地

            console.log('查询到的示范基地信息：', this.demonstrationBaseData);
          } else {
            console.error('查询示范基地信息失败：', res);
            this.demonstrationBaseData = [];
          }
          resolve();
        }).catch(err => {
          console.error('查询示范基地信息出错：', err);
          this.demonstrationBaseData = [];
          reject(err);
        });
      });
    },

    // 一次性获取所有街镇的特派员统计数据
    getAllTechPersonnelStats () {
      TechPersonnelController.getAllStats(this)
        .then(res => {
          console.log('所有街镇科技特派员统计数据:', res);
          if (res.data) {
            // 遍历所有街镇的数据
            for (const town in res.data) {
              const staticData = getTechPersonnelStaticData(town);
              const statsData = {
                provincial: res.data[town].provincial || 0,
                municipal: res.data[town].municipal || 0,
                district: res.data[town].district || 0,
                township: staticData.township,
                team: staticData.team,
                legalPerson: staticData.legalPerson
              };
              // 存储数据供tooltip使用
              this.techPersonnelStats[town] = statsData;
            }
          }
        })
        .catch(error => {
          console.error('获取所有街镇科技特派员统计数据失败:', error);
        });
    },

    // 获取特派员统计数据（从缓存中读取）
    getTechPersonnelStats (townStreet) {
      // 直接从缓存中读取数据，不再调用后台接口
      if (this.techPersonnelStats[townStreet]) {
        return;
      }
      // 如果缓存中没有数据，使用静态数据
      const staticData = getTechPersonnelStaticData(townStreet);
      this.techPersonnelStats[townStreet] = {
        provincial: 0,
        municipal: 0,
        district: staticData.district || 0,
        township: staticData.township,
        team: staticData.team,
        legalPerson: staticData.legalPerson
      };
    },

    // 添加教学点鼠标悬停事件监听
    addTeachingPointHoverEvent (chart) {
      console.log('addTeachingPointHoverEvent 被调用');
      chart.off('mouseover');
      chart.off('mouseout');

      chart.on('mouseover', (params) => {
        console.log('mouseover 事件触发', params);
        if (params.componentType === 'series' && params.seriesType === 'scatter') {
          const seriesName = params.seriesName;
          console.log('系列名称:', seriesName);
          if (seriesName === '教学点' || seriesName === 'specialTeachingPoint') {
            console.log('匹配到教学点，显示信息框');
            this.showTeachingPointInfoBox(params, chart);
          }
        }
      });

      chart.on('mouseout', (params) => {
        console.log('mouseout 事件触发', params);
        if (params.componentType === 'series' && params.seriesType === 'scatter') {
          const seriesName = params.seriesName;
          console.log('系列名称:', seriesName);
          if (seriesName === '教学点' || seriesName === 'specialTeachingPoint') {
            console.log('匹配到教学点，隐藏信息框');
            this.hideTeachingPointInfoBox();
          }
        }
      });
    },

    // 显示教学点信息框
    showTeachingPointInfoBox (params, chart) {
      console.log('showTeachingPointInfoBox 被调用', params);
      if (!params.data) {
        console.log('params.data 不存在');
        return;
      }

      const data = params.data.data || params.data;
      const location = data.location || '未知';
      const description = data.pointDesc || data.description || data.remark || '暂无简介';
      const imageUrl = data.imageUrl;

      // 获取标记点的屏幕坐标
      const geoCoord = params.data.value;
      console.log('地理坐标:', geoCoord);
      const pixelCoord = chart.convertToPixel('geo', geoCoord);
      console.log('屏幕坐标:', pixelCoord);

      if (!pixelCoord) {
        console.log('无法获取屏幕坐标');
        return;
      }

      // 计算信息框位置（在标记点右侧）
      // const infoBoxX = pixelCoord[0] + 20;
      // const infoBoxY = pixelCoord[1] - 100;

      // 更新specialTeachingPoint来显示信息
      this.specialTeachingPoint = {
        id: params.data.id,
        name: params.data.name,
        location: location,
        description: description,
        imageUrl: imageUrl,
        value: geoCoord,
        data: data
      };

      // 更新信息框位置（现在固定为50px，不需要动态计算）
      // this.specialTeachingPointInfoTop = infoBoxY;
      // this.arrowTop = infoBoxY + 125 - 15;

      // 更新连接线，使起点指向当前悬停的教学点
      this.updateConnectionLine();

      console.log('教学点信息框数据:', this.specialTeachingPoint);
    },

    // 隐藏教学点信息框
    hideTeachingPointInfoBox () {
      // 恢复原来的特殊教学点（如果有）
      if (this.cityName === '王台镇') {
        const specialTeachingPointData = this.teachingPointData.filter(item => item.id === 2);
        if (specialTeachingPointData.length > 0) {
          this.specialTeachingPoint = specialTeachingPointData[0];
          if (this.specialTeachingPoint.data) {
            this.specialTeachingPoint.location = this.specialTeachingPoint.data.location || '未知';
            this.specialTeachingPoint.description = this.specialTeachingPoint.data.pointDesc || this.specialTeachingPoint.data.description || this.specialTeachingPoint.data.remark || '暂无简介';
            this.specialTeachingPoint.imageUrl = this.specialTeachingPoint.data.imageUrl;
          }
          this.adjustInfoBoxPosition();
        } else {
          this.specialTeachingPoint = null;
        }
      } else {
        this.specialTeachingPoint = null;
      }
    },

    // 获取tooltip内容
    getTooltipContent (params) {
      if (!params.name) return '';

      // 当地图是延平区时，展示街镇的科技特派员统计信息
      if (this.cityName === '延平区') {
        // 存储当前悬停的街镇
        this.currentHoverTown = params.name;

        // 获取该街镇的特派员数据
        const staticData = getTechPersonnelStaticData(params.name);
        const stats = this.techPersonnelStats[params.name] || {
          provincial: 0,
          municipal: 0,
          district: staticData.district,
          township: staticData.township,
          team: staticData.team,
          legalPerson: staticData.legalPerson
        };

        // 构建美化的tooltip内容
        let content = '<div style="padding: 5px;">';
        content += `<div style="font-size: 16px; font-weight: bold; color: #00ff00; margin-bottom: 12px; text-align: center; border-bottom: 1px solid rgba(0,255,0,0.3); padding-bottom: 8px;">${params.name}</div>`;
        content += '<div style="line-height: 1.8;">';
        content += `<div style="display: flex; align-items: center;"><span style="color: #ff6b6b; margin-right: 8px;">●</span>省级科技特派员: <span style="color: #00ff00; margin-left: auto;">${stats.provincial}</span></div>`;
        content += `<div style="display: flex; align-items: center;"><span style="color: #ffa500; margin-right: 8px;">●</span>市级科技特派员: <span style="color: #00ff00; margin-left: auto;">${stats.municipal}</span></div>`;
        content += `<div style="display: flex; align-items: center;"><span style="color: #4ecdc4; margin-right: 8px;">●</span>区级科技特派员: <span style="color: #00ff00; margin-left: auto;">${stats.district}</span></div>`;
        content += `<div style="display: flex; align-items: center;"><span style="color: #a8e6cf; margin-right: 8px;">●</span>科技特派员团队: <span style="color: #00ff00; margin-left: auto;">${stats.team}</span></div>`;
        content += `<div style="display: flex; align-items: center;"><span style="color: #ffd93d; margin-right: 8px;">●</span>法人科技特派员: <span style="color: #00ff00; margin-left: auto;">${stats.legalPerson}</span></div>`;
        content += '</div></div>';

        return content;
      }

      // // 当地图不是延平区时，根据标记点类型展示不同的tooltip
      // const dataType = params.data?.data?.type;
      // const data = params.data?.data;
      //
      // if (!dataType) return '';
      //
      // let content = '';
      //
      // if (dataType === 'workstation') {
      //   content = this.getWorkstationTooltip(data);
      // } else if (dataType === 'teachingPoint') {
      //   content = this.getTeachingPointTooltip(data);
      // } else if (dataType === 'demonstrationBase') {
      //   content = this.getDemonstrationBaseTooltip(data);
      // }
      //
      // return content;
    },

    // 获取工作站tooltip内容
    getWorkstationTooltip (data) {
      if (!data) return '';

      let content = '<div style="padding: 5px;">';
      content += '<div style="font-size: 16px; font-weight: bold; color: #ff4757; margin-bottom: 12px; text-align: center; border-bottom: 1px solid rgba(255,71,87,0.3); padding-bottom: 8px;"> 工作站</div>';
      content += '<div style="line-height: 1.8;">';
      content += `<div style="display: flex; align-items: center;"><span style="color: #ff6b6b; margin-right: 8px;">📌</span>名称: <span style="color: #fff; margin-left: auto;">${data.name || '-'}</span></div>`;
      content += '</div></div>';

      return content;
    },

    // 获取教学点tooltip内容
    getTeachingPointTooltip (data) {
      if (!data) return '';
      if (this.cityName === '王台镇') return '';
      // 王台镇的教学点有特殊处理，不显示简介
      // const isWangtai = this.cityName === '王台镇';

      let content = '<div style="padding: 5px;">';
      content += '<div style="font-size: 16px; font-weight: bold; color: #2ed573; margin-bottom: 12px; text-align: center; border-bottom: 1px solid rgba(46,213,115,0.3); padding-bottom: 8px;"> 教学点</div>';
      content += '<div style="line-height: 1.8;">';
      content += `<div style="display: flex; align-items: center;"><span style="color: #2ed573; margin-right: 8px;">📌</span>名称: <span style="color: #fff; margin-left: auto;">${data.pointName || '-'}</span></div>`;
      content += '</div></div>';

      return content;
    },

    // 获取示范基地tooltip内容
    getDemonstrationBaseTooltip (data) {
      if (!data) return '';

      let content = '<div style="padding: 5px;">';
      content += '<div style="font-size: 16px; font-weight: bold; color: #ffa502; margin-bottom: 12px; text-align: center; border-bottom: 1px solid rgba(255,165,2,0.3); padding-bottom: 8px;"> 示范基地</div>';
      content += '<div style="line-height: 1.8;">';
      content += `<div style="display: flex; align-items: center;"><span style="color: #ffa502; margin-right: 8px;">📌</span>名称: <span style="color: #fff; margin-left: auto;">${data.name || '-'}</span></div>`;
      content += '</div></div>';

      return content;
    },

    // 切换标记点的显示状态
    toggleMarker (type) {
      this.showMarkers[type] = !this.showMarkers[type];
      console.log('切换标记点显示状态:', type, this.showMarkers[type]);
      // 强制更新地图，只显示当前选中的标记点
      this.forceUpdateMap();

      // 如果切换的是教学点，调整信息框位置
      if (type === 'teachingPoint' && this.showMarkers[type] && this.specialTeachingPoint) {
        setTimeout(() => {
          this.adjustInfoBoxPosition();
        }, 300);
      }
    },

    // 调整特殊教学点信息框位置，使箭头指向标记点
    adjustInfoBoxPosition () {
      if (!this.myChart || !this.specialTeachingPoint || !this.specialTeachingPoint.value || this.cityName !== '王台镇') return;

      try {
        // 获取标记点的地理坐标
        const geoCoord = this.specialTeachingPoint.value;
        if (!geoCoord || geoCoord.length < 2) return;

        // 将地理坐标转换为屏幕坐标
        const pixelCoord = this.myChart.convertToPixel('geo', geoCoord);
        if (!pixelCoord) return;

        // 计算信息框位置
        // 假设信息框宽度为350px，右侧距离地图30px
        const mapContainer = document.getElementById('bigScreen-map');
        if (!mapContainer) return;

        const mapRect = mapContainer.getBoundingClientRect();
        const infoBoxHeight = 250; // 估算高度

        // 计算信息框顶部位置，使箭头垂直居中指向标记点
        let infoTop = pixelCoord[1] - infoBoxHeight / 2;

        // 确保信息框不会超出地图容器
        if (infoTop < 0) {
          infoTop = 20;
        } else if (infoTop + infoBoxHeight > mapRect.height - 80) {
          // 预留80px空间给返回按钮（返回按钮在bottom: 30px）
          infoTop = mapRect.height - infoBoxHeight - 80;
        }

        // 计算箭头顶部位置，使其指向标记点
        // 箭头应该指向标记点的中心，所以需要计算箭头在信息框中的相对位置
        const arrowTop = pixelCoord[1] - infoTop - 15; // 减去箭头高度的一半(15px)，使箭头中心指向标记点

        // 更新位置
        this.specialTeachingPointInfoTop = infoTop;
        this.arrowTop = arrowTop;

        // 更新连接线
        this.updateConnectionLine();

        console.log('调整特殊教学点信息框位置:', { infoTop, arrowTop, pixelCoord, mapHeight: mapRect.height });
      } catch (error) {
        console.error('调整信息框位置失败:', error);
      }
    },

    // 更新连接线
    updateConnectionLine () {
      if (!this.myChart || !this.specialTeachingPoint || !this.specialTeachingPoint.value || this.cityName !== '王台镇') {
        this.clearConnectionLine();
        return;
      }

      try {
        // 获取当前选项
        const option = this.myChart.getOption();

        // 移除现有的连接线
        option.series = option.series.filter(series => series.name !== 'connectionLine');

        // 获取标记点的地理坐标
        const geoCoord = this.specialTeachingPoint.value;
        if (!geoCoord || geoCoord.length < 2) return;

        // 计算信息框的屏幕坐标
        const mapContainer = document.getElementById('bigScreen-map');
        if (!mapContainer) return;

        const mapRect = mapContainer.getBoundingClientRect();
        const infoBoxWidth = 350;
        const infoBoxHeight = 250;

        // 信息框左侧边缘的屏幕坐标
        const infoBoxLeft = mapRect.width - 30 - infoBoxWidth;
        const infoBoxTop = 50; // 固定为50px，与信息框的top位置一致

        // 信息框左侧边缘的中心点屏幕坐标
        const infoBoxCenterX = infoBoxLeft;
        const infoBoxCenterY = infoBoxTop + infoBoxHeight / 2;

        // 将屏幕坐标转换为地理坐标
        const infoBoxGeoCoord = this.myChart.convertFromPixel('geo', [infoBoxCenterX, infoBoxCenterY]);
        if (!infoBoxGeoCoord) return;

        // 添加连接线
        option.series.push({
          name: 'connectionLine',
          type: 'lines',
          coordinateSystem: 'geo',
          zlevel: 3,
          // effect: {
          //   show: true,
          //   period: 6, // 箭头指向速度，值越小速度越快
          //   trailLength: 0.3, // 特效尾迹长度[0,1]值越大，尾迹越长
          //   symbol: 'arrow', // 箭头图标
          //   symbolSize: 6, // 图标大小
          //   color: '#00ff00' // 特效颜色
          // },
          lineStyle: {
            normal: {
              width: 2, // 线条宽度
              opacity: 0.8,
              curveness: 0.2, // 线条曲度
              color: '#fff' // 线条颜色改为红色
            }
          },
          data: [{
            fromName: this.specialTeachingPoint.name,
            toName: '信息框',
            coords: [geoCoord, infoBoxGeoCoord],
            value: 1
          }]
        });

        // 更新图表
        this.myChart.setOption(option);
      } catch (error) {
        console.error('更新连接线失败:', error);
      }
    },

    // 清除连接线
    clearConnectionLine () {
      if (!this.myChart) return;
      try {
        const option = this.myChart.getOption();
        option.series = option.series.filter(series => series.name !== 'connectionLine');
        this.myChart.setOption(option);
      } catch (error) {
        console.error('清除连接线失败:', error);
      }
    },

    // 刷新地图数据
    refreshMap () {
      this.forceUpdateMap();
    },

    // 强制更新地图数据
    forceUpdateMap () {
      if (!this.myChart) {
        console.warn('地图实例不存在，无法更新数据');
        return;
      }

      // console.log('开始强制更新地图数据');
      // console.log('当前工作站数据:', this.mapData);
      // console.log('当前教学点数据:', this.teachingPointData);

      try {
        // 重新构建完整的地图选项
        // let zoom = 1.2; // 延平区缩放级别
        // if (this.cityName !== '延平区') {
        //   zoom = 0.9; // 其他区域缩放级别
        // }

        const option = {
          geo: this.myChart.getOption().geo,
          series: this.myChart.getOption().series.filter(series => series.type !== 'effectScatter' && series.type !== 'scatter'),
          tooltip: {
            formatter: (params) => {
              return this.getTooltipContent(params);
            }
          }
        };

        if (this.cityName !== '延平区' && this.showMarkers.workstation && this.mapData.length > 0) {
          console.log('添加工作站标记，数量:', this.mapData.length);
          option.series.push({
            name: '工作站',
            type: 'scatter',
            coordinateSystem: 'geo',
            z: 20,
            label: {
              show: false,
              formatter: '{b}',
              offset: [0, -25],
              color: '#ffffff',
              fontSize: 14,
              fontWeight: 'bold',
              fontFamily: 'Microsoft YaHei, Arial, sans-serif',
              backgroundColor: 'linear-gradient(135deg, rgba(30, 144, 255, 0.9) 0%, rgba(0, 100, 200, 0.95) 100%)',
              borderColor: '#1e90ff',
              borderWidth: 2,
              padding: [8, 15, 8, 15],
              borderRadius: 8,
              shadowBlur: 15,
              shadowColor: 'rgba(30, 144, 255, 0.6)',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              width: 'auto',
              overflow: 'truncate',
              ellipsis: '...'
            },
            emphasis: {
              label: {
                show: true,
                color: '#ffffff',
                fontSize: 15,
                backgroundColor: 'linear-gradient(135deg, rgba(65, 175, 255, 0.95) 0%, rgba(0, 120, 220, 1) 100%)',
                borderColor: '#41afff',
                borderWidth: 2,
                shadowBlur: 20,
                shadowColor: 'rgba(30, 144, 255, 0.8)'
              }
            },
            hoverAnimation: false, // 禁用悬停动画
            // 移除silent属性，以便鼠标悬停事件可以触发emphasis状态
            symbol: 'image://' + require('../../../assets/img/bigScreen/list2.png'),
            symbolSize: [40, 50], // 图标大小
            itemStyle: {
              normal: {
                color: 'red', // 工作站使用红色标记
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            // symbolSize: 10, // 设置标记大小
            data: this.mapData
          });
        }

        // 添加教学点标记
        if (this.cityName !== '延平区' && this.showMarkers.teachingPoint && this.teachingPointData.length > 0) {
          console.log('添加教学点标记，数量:', this.teachingPointData.length);
          // 为id为1的教学点创建单独的系列
          const specialTeachingPointData = this.teachingPointData.filter(item => item.id === 2);
          const normalTeachingPointData = this.teachingPointData.filter(item => item.id !== 2);

          // 存储特殊教学点数据用于信息框显示（只有在王台镇时才自动显示）
          if (specialTeachingPointData.length > 0 && this.cityName === '王台镇') {
            this.specialTeachingPoint = specialTeachingPointData[0];
            // 解析其他信息
            if (this.specialTeachingPoint.data) {
              this.specialTeachingPoint.location = this.specialTeachingPoint.data.location || '未知';
              this.specialTeachingPoint.description = this.specialTeachingPoint.data.pointDesc || this.specialTeachingPoint.data.description || this.specialTeachingPoint.data.remark || '暂无简介';
              this.specialTeachingPoint.imageUrl = this.specialTeachingPoint.data.imageUrl;
            }

            // 调整信息框位置，使箭头指向标记点
            this.adjustInfoBoxPosition();
          } else {
            // 其他情况下不自动显示，只有鼠标悬停时才显示
            this.specialTeachingPoint = null;
          }

          // 添加普通教学点标记
          if (normalTeachingPointData.length > 0) {
            option.series.push({
              name: '教学点',
              type: 'scatter',
              coordinateSystem: 'geo',
              z: 25,
              label: {
                show: false,
                formatter: '{b}',
                offset: [0, -30],
                color: '#ffffff',
                fontSize: 14,
                fontWeight: 'bold',
                fontFamily: 'Microsoft YaHei, Arial, sans-serif',
                backgroundColor: 'linear-gradient(135deg, rgba(255, 165, 0, 0.9) 0%, rgba(220, 100, 0, 0.95) 100%)',
                borderColor: '#ffa500',
                borderWidth: 2,
                padding: [8, 15, 8, 15],
                borderRadius: 8,
                shadowBlur: 15,
                shadowColor: 'rgba(255, 165, 0, 0.6)',
                shadowOffsetX: 0,
                shadowOffsetY: 3,
                width: 'auto',
                overflow: 'truncate',
                ellipsis: '...'
              },
              emphasis: {
                label: {
                  show: true,
                  color: '#ffffff',
                  fontSize: 15,
                  backgroundColor: 'linear-gradient(135deg, rgba(255, 180, 30, 0.95) 0%, rgba(240, 120, 0, 1) 100%)',
                  borderColor: '#ffb41e',
                  borderWidth: 2,
                  shadowBlur: 20,
                  shadowColor: 'rgba(255, 165, 0, 0.8)'
                }
              },
              hoverAnimation: false,
              symbol: 'image://' + require('../../../assets/img/bigScreen/list1.png'),
              symbolSize: [40, 50],
              itemStyle: {
                normal: {
                  shadowBlur: 15,
                  shadowColor: '#00ff00',
                  shadowOffsetY: 5
                }
              },
              z: 10,
              data: normalTeachingPointData
            });
          }

          // 添加id为1的特殊教学点标记
          if (specialTeachingPointData.length > 0) {
            option.series.push({
              name: 'specialTeachingPoint',
              type: 'scatter',
              coordinateSystem: 'geo',
              z: 30,
              label: {
                show: false
              },
              hoverAnimation: false,
              // symbol: 'path://M512 0l198.4 601.6 633.6 49.6-483.2 416 144 633.6-492.8-300.8-492.8 300.8 144-633.6-483.2-416 633.6-49.6z', // 使用SVG路径绘制五角星
              symbol: 'image://' + require('../../../assets/img/bigScreen/list1.png'),
              symbolSize: 50, // 稍大一点以突出显示
              itemStyle: {
                normal: {
                  color: '#ff0000', // 红色
                  shadowBlur: 20,
                  shadowColor: '#ff0000', // 使用红色阴影以突出显示
                  shadowOffsetY: 8
                }
              },
              z: 11, // 确保显示在普通教学点之上
              data: specialTeachingPointData
            });
          }
        }

        // 添加示范基地标记
        if (this.cityName !== '延平区' && this.showMarkers.demonstrationBase && this.demonstrationBaseData.length > 0) {
          console.log('添加示范基地标记，数量:', this.demonstrationBaseData.length);
          option.series.push({
            name: '示范基地',
            type: 'scatter',
            coordinateSystem: 'geo',
            z: 20,
            label: {
              show: false,
              formatter: '{b}',
              offset: [0, -25],
              color: '#ffffff',
              fontSize: 14,
              fontWeight: 'bold',
              fontFamily: 'Microsoft YaHei, Arial, sans-serif',
              backgroundColor: 'linear-gradient(135deg, rgba(147, 112, 219, 0.9) 0%, rgba(100, 50, 180, 0.95) 100%)',
              borderColor: '#9370db',
              borderWidth: 2,
              padding: [8, 15, 8, 15],
              borderRadius: 8,
              shadowBlur: 15,
              shadowColor: 'rgba(147, 112, 219, 0.6)',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              width: 'auto',
              overflow: 'truncate',
              ellipsis: '...'
            },
            emphasis: {
              label: {
                show: true,
                color: '#ffffff',
                fontSize: 15,
                backgroundColor: 'linear-gradient(135deg, rgba(167, 132, 239, 0.95) 0%, rgba(120, 70, 200, 1) 100%)',
                borderColor: '#a784ef',
                borderWidth: 2,
                shadowBlur: 20,
                shadowColor: 'rgba(147, 112, 219, 0.8)'
              }
            },
            hoverAnimation: false, // 禁用悬停动画
            // 移除silent属性，以便鼠标悬停事件可以触发emphasis状态
            symbol: 'image://' + require('../../../assets/img/bigScreen/list3.png'),
            symbolSize: [40, 50], // 图标大小
            // symbolSize: 15, // 设置标记大小
            itemStyle: {
              normal: {
                color: 'yellow', // 示范基地使用黄色标记
                shadowBlur: 10,
                shadowColor: '#ffff00'
              }
            },
            z: 8, // 确保图标显示在适当位置
            data: this.demonstrationBaseData
          });
        }

        // 强制更新地图选项
        console.log('准备更新地图选项');
        this.myChart.setOption(option, true);
        console.log('地图更新完成');

        // 重新添加鼠标事件监听
        this.addTeachingPointHoverEvent(this.myChart);

        // 额外触发一次地图渲染
        setTimeout(() => {
          if (this.myChart) {
            console.log('额外触发地图resize');
            this.myChart.resize();
            // 只在王台镇时更新连接线
            if (this.specialTeachingPoint && this.showMarkers.teachingPoint && this.cityName === '王台镇') {
              this.updateConnectionLine();
            } else {
              // 其他街镇清除连接线
              this.clearConnectionLine();
            }
          }
        }, 50);
      } catch (error) {
        console.error('强制更新地图数据失败：', error);
      }
    }

  },

  beforeRouteLeave () {
    this.timer = null;
  },
  beforeDestroy () {
    /* 页面组件销毁的时候，别忘了移除绑定的监听resize事件，否则的话，多渲染几次
     容易导致内存泄漏和额外CPU或GPU占用哦 */
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  }

}
</script>

<style scoped>
.special-teaching-point-info {
  width: 350px;
}

.info-box {
  background: linear-gradient(135deg, rgba(0, 128, 0, 0.9) 0%, rgba(0, 80, 0, 0.9) 100%);
  border: 2px solid #00ff00;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
  overflow: hidden;
}

.info-header {
  padding: 15px;
  border-bottom: 1px solid #00ff00;
  background-color: rgba(0, 80, 0, 0.8);
}

.info-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.info-content {
  padding: 15px;
}

.info-image {
  margin-bottom: 15px;
  text-align: center;
}

.teaching-point-image {
  max-width: 100%;
  max-height: 150px;
  border-radius: 6px;
  border: 1px solid #00ff00;
  cursor: pointer;
}

.image-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 150px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  border: 1px solid #00ff00;
}

.image-error i {
  font-size: 40px;
  color: #00ff00;
}

.info-details {
  color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
}

.info-details p {
  margin: 8px 0;
  padding: 5px;
  background-color: rgba(0, 160, 0, 0.3);
  border-radius: 4px;
  border-left: 3px solid #00ff00;
}

.info-details strong {
  color: #00ff00;
}
</style>

<style scoped>

</style>
